import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Nav from './Nav/Nav';
import ClientBusiness from './ClientBusiness/Index';
import Users from './Users/Index';

import './client-business-info-index.css';

class ClientBusinessInfoAndUser extends Component {
  render () {
    return (
      <MuiThemeProvider>
        <div className="client-business-user-wrapper">
          <Nav
            params={this.props.match.params}
          />
          {this.props.match.params.type === 'client-business-info' && (
            <ClientBusiness {...this.props}/>
          )}
          {
            this.props.match.params.type === 'users' && (
              <Users {...this.props}
              />
            )
          }
        </div>
      </MuiThemeProvider>
    )
  }
}

export default ClientBusinessInfoAndUser;



// WEBPACK FOOTER //
// ./src/components/ClientBusinessInfoAndUser/Index.jsx